import {
  Input,
  Table,
  Typography,
  Pagination,
  Select,
  Form,
  Checkbox,
  CheckboxProps,
  Tag,
  Modal,
  Button,
  Space,
  DatePicker,
  DatePickerProps,
  Popconfirm,
  Spin,
} from "antd";
import React, { Dispatch, useEffect, useState } from "react";
import { IFormattedSelectItem, ISiteRow, SortByField } from "../../types";
import { useSearchParams } from "react-router-dom";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { AppStateType } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import {
  SiteThunkType,
  getSites,
  setPage,
  setPageSize,
  setSearchByCity,
  setSearchByCompany,
  setSearchByCounty,
  setSearchByError,
  setSearchByInProgress,
  setSearchByLabels,
  setSearchByName,
  setSearchByState,
  setSearchByStatus,
  setSearchByZip,
  setSerchByDomain,
  setSortBy,
  setSortByField,
  writeArticle,
} from "../../store/actions/siteActions";
import { AnyAction } from "redux";
import { getBeautifullDate, timeAgo } from "../../helpers/helpers";
import { SearchCityInput } from "./SearchCityInput";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { ThunderboltOutlined } from "@ant-design/icons";
import { getCompanies } from "../../store/actions/companyActions";
import { SearchCountyInput } from "./SearchCountyInput";
import { mainUrl } from "../../helpers/constants";
import axios from "axios";
import {
  loadStatistic,
  setStatistics,
} from "../../store/actions/domainActions";

interface IProps {
  checkedSites: string[];
  setCheckedSites: (param: string[]) => void;
}

export const SitesList = ({ checkedSites, setCheckedSites }: IProps) => {
  const dispatch = useDispatch() as Dispatch<SiteThunkType | AnyAction>;
  const [dataSource, setDataSource] = useState<ISiteRow[]>([]);
  const [allSitesIds, setAllSitesIds] = useState<string[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeDomain, setActiveDomain] = useState("");
  const [activeSiteId, setActiveSiteId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [finishDate, setFinishDate] = useState("");
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [isExportExpirationModalOpen, setIsExportExpirationModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState<string[]>([
    "name",
    "state",
    "city",
    "zip",
    "county",
    "company",
    "domain",
    "status",
    "created",
    "updated",
  ]);

  const [columns, setColumns] = useState<any[]>([]);
  let [searchParams, setSearchParams] = useSearchParams();
  const [currentSearchParams, setCurrentSearchParams] = useState<{
    [param: string]: string;
  }>();
  const [formattedStates, setFormattedStates] = useState(
    [] as IFormattedSelectItem[]
  );
  const [allLabels, setAllLabels] = useState<any[]>([]);
  const { Text, Link } = Typography;
  const clickSortByField = (param: SortByField) => {
    setSearchParams({
      ...currentSearchParams,
      sortByField: param,
      sortBy: "asc",
      page: "1",
    });
  };
  const sortBy = useSelector((state: AppStateType) => state.site.sortBy);
  const sortByField = useSelector(
    (state: AppStateType) => state.site.sortByField
  );
  const sites = useSelector((state: AppStateType) => state.site.sites);
  const states = useSelector((state: AppStateType) => state.location.states);
  const isLoadStatisticInProgress = useSelector(
    (state: AppStateType) => state.domain.isLoadStatisticInProgress
  );
  const statistics = useSelector(
    (state: AppStateType) => state.domain.statistics
  );
  const companies = useSelector(
    (state: AppStateType) => state.company.companies
  );
  const isGettingSitesInProgress = useSelector(
    (state: AppStateType) => state.site.isGettingSitesInProgress
  );
  const sitesTotal = useSelector(
    (state: AppStateType) => state.site.sitesTotal
  );
  const pageSize = useSelector((state: AppStateType) => state.site.pageSize);
  const isWritingArticleInProgress = useSelector(
    (state: AppStateType) => state.site.isWritingArticleInProgress
  );

  // const inProgressId = useSelector(
  //   (state: AppStateType) => state.site.inProgressId
  // );

  const isGettingStatesInProgress = useSelector(
    (state: AppStateType) => state.location.isGettingStatesInProgress
  );
  const getArrowIcon = () => {
    return sortBy === "asc" ? <ArrowUpOutlined /> : <ArrowDownOutlined />;
  };
  const setSort = () => {
    if (currentSearchParams?.sortBy === "asc") {
      setSearchParams({ ...currentSearchParams, sortBy: "desc", page: "1" });
    } else {
      setSearchParams({ ...currentSearchParams, sortBy: "asc", page: "1" });
    }
  };

  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  useEffect(() => {
    const arr = [] as IFormattedSelectItem[];
    states.forEach((s) => {
      arr.push({ value: s._id, label: s.State });
    });
    setFormattedStates(arr);
  }, [states]);

  useEffect(() => {
    dispatch(getCompanies());
    loadAllLabels();
  }, []);

  // Trigger getSites when calls filter params change
  useEffect(() => {
    // Always trigger on dependency change (including when cleared)
    dispatch(getSites());
  }, [
    currentSearchParams?.callsCountFrom,
    currentSearchParams?.callsCountTo,
    currentSearchParams?.callsCount2MonthsFrom,
    currentSearchParams?.callsCount2MonthsTo,
    currentSearchParams?.domainStatusText,
    currentSearchParams?.domainAutoRenew,
    currentSearchParams?.domainRegistrar,
    currentSearchParams?.domainProject,
    currentSearchParams?.domainDaysUntilValidFrom,
    currentSearchParams?.domainDaysUntilValidTo
  ]);

  const loadAllLabels = async () => {
    try {
      const token = localStorage.getItem("token");
      const instance = axios.create({
        baseURL: mainUrl,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const res = await instance.get<any>("api/v1/label");
      if (res.data.status === "success") {
        console.log("Loaded labels:", res.data.labels);
        setAllLabels(res.data.labels || []);
      }
    } catch (error) {
      console.error("Error loading labels:", error);
    }
  };

  const getStatusType = (status: string) => {
    if (status === "with_domain") {
      return "blue";
    }
    if (status === "with_content") {
      return "green";
    }
    if (status === "with_html") {
      return "red";
    }
    return "gold";
  };

  const onChange = (
    e: CheckboxChangeEvent,
    siteId: string,
    checked: string[]
  ) => {
    if (!e.target.checked) {
      setCheckedSites([...checked.filter((cs) => cs !== siteId)]);
    } else {
      setCheckedSites([...checked, siteId]);
    }
  };

  const checkAll = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      setCheckedSites(allSitesIds);
    } else {
      setCheckedSites([]);
    }
  };

  useEffect(() => {
    const ds = [] as ISiteRow[];
    const sitesIds = [] as string[];
    sites.forEach((s) => {
      sitesIds.push(s._id.toString());
      ds.push({
        key: s._id,
        check: (
          <Checkbox
            checked={checkedSites.includes(s._id)}
            onChange={(e) => onChange(e, s._id, checkedSites)}
          ></Checkbox>
        ),
        logo: (
          <div>
            {s.companyLogo ? (
              <img
                width={50}
                alt="company logo"
                src={`${mainUrl}${s?.companyLogo?.replace(
                  "/data/uploads/",
                  ""
                )}`}
              />
            ) : (
              ""
            )}
          </div>
        ),
        name: (
          <div>
            <div>
              <Link
                style={{ color: s.error ? "red" : undefined }}
                href={`/sites/${s._id}`}
              >
                {s.statusAutoProgressOnCreate && (
                  <>
                    <ThunderboltOutlined style={{ color: "green" }} />{" "}
                  </>
                )}
                {s.isInProgress && (
                  <>
                    <LoadingOutlined style={{ color: "red" }} />{" "}
                  </>
                )}
                {s.name}
              </Link>
            </div>
            <div>
              {s.companyLocalName}{" "}
              <InfoCircleOutlined
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setActiveDomain(`https://${s.domain}`);
                  setActiveSiteId(String(s._id));
                  showModal();
                  dispatch(setStatistics(""));
                }}
              />
            </div>
          </div>
        ),
        state: s.state?.State,
        city: s.city.city,
        zip: s?.zip,
        county: s.county.county_full,
        company: (
          <Tag color={s.company.color || "#2db7f5"}>{s.company.name}</Tag>
        ),
        domain: s.domain ? (
          <a target="_blank" href={`https://${s.domain}`}>
            {s.domain}
          </a>
        ) : (
          ""
        ),
        created: (
          <>
            <div>{getBeautifullDate(s.createdAt)}</div>
            <div>~{timeAgo(s.createdAt)}</div>
          </>
        ),
        updated: (
          <>
            <div>{getBeautifullDate(s.updatedAt)}</div>
            <div>~{timeAgo(s.updatedAt)}</div>
          </>
        ),
        isError: s.error ? <Tag color="#f50">ERROR</Tag> : "",
        inProgress: `${s.isInProgress}`,
        //status: s.status,
        status: <Tag color={getStatusType(s.status)}>{s.status}</Tag>,
        labels: (
          <div>
            {s.labels && s.labels.length > 0 && (
              <>
                {s.labels.map((label: any) => (
                  <Tag
                    key={label._id}
                    color={label.color}
                    closable
                    onClose={async (e) => {
                      e.preventDefault();
                      try {
                        const token = localStorage.getItem("token");
                        const instance = axios.create({
                          baseURL: mainUrl,
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          },
                        });
                        const res = await instance.post<any>(
                          "api/v1/label/remove-from-site",
                          {
                            siteId: s._id,
                            labelId: label._id,
                          }
                        );
                        if (res.data.status === "success") {
                          dispatch(getSites());
                        }
                      } catch (error) {
                        console.error("Error removing label:", error);
                      }
                    }}
                  >
                    {label.name}
                  </Tag>
                ))}
              </>
            )}
          </div>
        ),
        callsCount: String(s.callsCount || 0),
        callsCount2Months: String(s.callsCount2Months || 0),
        conversionCallsCount: (
          <span
            style={
              s.conversionCallsCount
                ? { color: "#52c41a", fontWeight: 600 }
                : undefined
            }
          >
            {String(s.conversionCallsCount || 0)}
          </span>
        ),
        domainStatusText: s.domainStatusText || "",
        domainAutoRenew: s.domainAutoRenew !== undefined ? String(s.domainAutoRenew) : "",
        domainRegistrar: s.domainRegistrar !== undefined ? String(s.domainRegistrar) : "",
        domainProject: s.domainProject !== undefined ? String(s.domainProject) : "",
        domainDaysUntilValid: s.domainDaysUntilValid !== undefined ? String(s.domainDaysUntilValid) : "",
      });
    });
    setDataSource(ds);
    setAllSitesIds(sitesIds);
  }, [sites, checkedSites]);

  const handleChangeState = (value: string) => {
    if (value.length > 0) {
      setSearchParams({
        ...currentSearchParams,
        page: "1",
        state: value.toString(),
      });
    } else {
      searchParams.delete("state");
      setSearchParams(searchParams);
    }
  };

  const handleChangeCompany = (value: string) => {
    if (value.length > 0) {
      setSearchParams({
        ...currentSearchParams,
        page: "1",
        company: value.toString(),
      });
    } else {
      searchParams.delete("company");
      setSearchParams(searchParams);
    }
  };
  const handleChangeStatus = (value: string) => {
    if (value.length > 0) {
      setSearchParams({
        ...currentSearchParams,
        page: "1",
        status: value.toString(),
      });
    } else {
      searchParams.delete("status");
      setSearchParams(searchParams);
    }
  };

  const handleChangeIsError = (value: string) => {
    setSearchParams({
      ...currentSearchParams,
      page: "1",
      error: value.toString(),
    });
  };

  const handleChangeInProgress = (value: string) => {
    setSearchParams({
      ...currentSearchParams,
      page: "1",
      inProgress: value.toString(),
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (activeDomain && startDate && finishDate) {
      dispatch(loadStatistic(activeDomain, startDate, finishDate));
    }
  }, [activeDomain, startDate, finishDate]);

  useEffect(() => {
    setColumns([
      {
        title: () => (
          <div>
            <Checkbox
              indeterminate={
                checkedSites.length > 0 &&
                checkedSites.length !== allSitesIds.length
              }
              checked={
                allSitesIds.length > 0 &&
                checkedSites.length === allSitesIds.length
              }
              onChange={checkAll}
            ></Checkbox>
          </div>
        ),
        dataIndex: "check",
        key: "check",
      },
      {
        title: "Logo",
        dataIndex: "logo",
        key: "logo",
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Site name</span>
            <Form
              name="form_sitename"
              fields={[
                {
                  name: ["sitename"],
                  value: currentSearchParams?.serchByName || "",
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="sitename">
                <Input
                  allowClear
                  style={{ width: 140 }}
                  onBlur={(e) => {
                    if (e.target.value) {
                      setSearchParams({
                        ...currentSearchParams,
                        page: "1",
                        serchByName: e.target.value,
                      });
                    } else {
                      searchParams.delete("serchByName");
                      setSearchParams(searchParams);
                    }
                  }}
                  onChange={(e) => {
                    if (e.target.value === "") {
                      // Логика при очистке
                      searchParams.delete("serchByName");
                      setSearchParams(searchParams);
                    }
                  }}
                  onPressEnter={(e) => {
                    const target = e.target as HTMLInputElement; // Явное приведение к HTMLInputElement
                    target.blur(); // Вызываем onBlur вручную
                  }}
                  size="small"
                  placeholder="Search by name"
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "name",
        key: "name",
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>State</span>
            <Form
              name="form_states"
              fields={[
                {
                  name: ["states"],
                  value: currentSearchParams?.state?.split(",") || [],
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="states">
                <Select
                  mode="tags"
                  size="small"
                  loading={isGettingStatesInProgress}
                  showSearch
                  style={{ minWidth: 120 }}
                  placeholder="Filter by state"
                  onChange={handleChangeState}
                  optionFilterProp="children"
                  options={formattedStates}
                  filterOption={filterOption}
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "state",
        key: "state",
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>County</span>
            <SearchCountyInput currentSearchParams={currentSearchParams} />
          </div>
        ),
        dataIndex: "county",
        key: "county",
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>City</span>
            <SearchCityInput currentSearchParams={currentSearchParams} />
          </div>
        ),
        dataIndex: "city",
        key: "city",
      },
      {
        title: (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Zip</span>
            <Form
              name="form_zip"
              fields={[
                {
                  name: ["sitezip"],
                  value: currentSearchParams?.serchByZip || "",
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="sitezip">
                <Input
                  allowClear
                  style={{ width: 100 }}
                  onBlur={(e) => {
                    if (e.target.value) {
                      setSearchParams({
                        ...currentSearchParams,
                        page: "1",
                        serchByZip: e.target.value,
                      });
                    } else {
                      searchParams.delete("serchByZip");
                      setSearchParams(searchParams);
                    }
                  }}
                  onChange={(e) => {
                    if (e.target.value === "") {
                      // Срабатывает, когда поле очищено
                      searchParams.delete("serchByZip");
                      setSearchParams(searchParams);
                    }
                  }}
                  onPressEnter={(e) => {
                    const target = e.target as HTMLInputElement; // Явное приведение к типу HTMLInputElement
                    target.blur(); // Триггерим onBlur вручную
                  }}
                  size="small"
                  placeholder="Zip"
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "zip",
        key: "zip",
      },
      {
        title: (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Domain</span>
            <Form
              name="form_domain"
              fields={[
                {
                  name: ["sitedomain"],
                  value: currentSearchParams?.serchByDomain || "",
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="sitedomain">
                <Input
                  allowClear
                  style={{ width: 140 }}
                  onBlur={(e) => {
                    if (e.target.value) {
                      setSearchParams({
                        ...currentSearchParams,
                        page: "1",
                        serchByDomain: e.target.value,
                      });
                    } else {
                      searchParams.delete("serchByDomain");
                      setSearchParams(searchParams);
                    }
                  }}
                  onChange={(e) => {
                    if (e.target.value === "") {
                      // Логика при очистке
                      searchParams.delete("serchByDomain");
                      setSearchParams(searchParams);
                    }
                  }}
                  onPressEnter={(e) => {
                    const target = e.target as HTMLInputElement; // Явное приведение к HTMLInputElement
                    target.blur(); // Вызываем onBlur вручную
                  }}
                  size="small"
                  placeholder="Domain"
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "domain",
        key: "domain",
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Company</span>
            <Form
              name="form_companies"
              fields={[
                {
                  name: ["companies"],
                  value: currentSearchParams?.company?.split(",") || [],
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="companies">
                <Select
                  mode="tags"
                  size="small"
                  loading={isGettingStatesInProgress}
                  showSearch
                  style={{ minWidth: 120 }}
                  placeholder="Company"
                  onChange={handleChangeCompany}
                  optionFilterProp="children"
                  options={[
                    ...companies.map((c) => ({ value: c._id, label: c.name })),
                  ]}
                  filterOption={filterOption}
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "company",
        key: "company",
      },

      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Status</span>
            <Form
              name="form_statuses"
              fields={[
                {
                  name: ["statuses"],
                  value: currentSearchParams?.status?.split(",") || [],
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="statuses">
                <Select
                  mode="tags"
                  size="small"
                  loading={isGettingStatesInProgress}
                  showSearch
                  style={{ minWidth: 120 }}
                  placeholder="Status"
                  onChange={handleChangeStatus}
                  optionFilterProp="children"
                  options={[
                    { value: "initial", label: "initial" },
                    { value: "with_domain", label: "with_domain" },
                    { value: "with_content", label: "with_content" },
                    { value: "with_html", label: "with_html" },
                  ]}
                  filterOption={filterOption}
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "status",
        key: "status",
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>In Progress</span>
            <Form
              name="form_in_progress"
              fields={[
                {
                  name: ["inProgress"],
                  value: currentSearchParams?.inProgress || "",
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="inProgress">
                <Select
                  size="small"
                  showSearch
                  style={{ minWidth: 80 }}
                  placeholder="In Progress"
                  onChange={handleChangeInProgress}
                  optionFilterProp="children"
                  options={[
                    { value: "true", label: "true" },
                    { value: "false", label: "false" },
                  ]}
                  filterOption={filterOption}
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "inProgress",
        key: "inProgress",
      },
      {
        title: (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Link
              onClick={() => {
                currentSearchParams?.sortByField !== "callsCount"
                  ? clickSortByField("callsCount")
                  : setSort();
              }}
              style={{ marginBottom: 4 }}
            >
              {sortByField === "callsCount" && getArrowIcon()} Total Calls
            </Link>
            <div style={{ display: "flex", gap: 4 }}>
              <Form
                name="form_callsCount_from"
                fields={[
                  {
                    name: ["callsCountFrom"],
                    value: currentSearchParams?.callsCountFrom || "",
                  },
                ]}
              >
                <Form.Item style={{ margin: 0, padding: 0 }} name="callsCountFrom">
                  <Input
                    type="number"
                    allowClear
                    style={{ width: 60 }}
                    onBlur={(e) => {
                      if (e.target.value) {
                        setSearchParams({
                          ...currentSearchParams,
                          page: "1",
                          callsCountFrom: e.target.value,
                        });
                      } else {
                        searchParams.delete("callsCountFrom");
                        setSearchParams(searchParams);
                      }
                    }}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        searchParams.delete("callsCountFrom");
                        setSearchParams(searchParams);
                      }
                    }}
                    onPressEnter={(e) => {
                      const target = e.target as HTMLInputElement;
                      target.blur();
                    }}
                    size="small"
                    placeholder="From"
                  />
                </Form.Item>
              </Form>
              <Form
                name="form_callsCount_to"
                fields={[
                  {
                    name: ["callsCountTo"],
                    value: currentSearchParams?.callsCountTo || "",
                  },
                ]}
              >
                <Form.Item style={{ margin: 0, padding: 0 }} name="callsCountTo">
                  <Input
                    type="number"
                    allowClear
                    style={{ width: 60 }}
                    onBlur={(e) => {
                      if (e.target.value) {
                        setSearchParams({
                          ...currentSearchParams,
                          page: "1",
                          callsCountTo: e.target.value,
                        });
                      } else {
                        searchParams.delete("callsCountTo");
                        setSearchParams(searchParams);
                      }
                    }}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        searchParams.delete("callsCountTo");
                        setSearchParams(searchParams);
                      }
                    }}
                    onPressEnter={(e) => {
                      const target = e.target as HTMLInputElement;
                      target.blur();
                    }}
                    size="small"
                    placeholder="To"
                  />
                </Form.Item>
              </Form>
            </div>
          </div>
        ),
        dataIndex: "callsCount",
        key: "callsCount",
        width: 250,
        minWidth: 250,
        render: (text: string) => (
          <div
            style={{ whiteSpace: "nowrap", minWidth: "35px", width: "35px" }}
          >
            {text}
          </div>
        ),
      },
      {
        title: (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Link
              onClick={() => {
                currentSearchParams?.sortByField !== "callsCount2Months"
                  ? clickSortByField("callsCount2Months")
                  : setSort();
              }}
              style={{ marginBottom: 4 }}
            >
              {sortByField === "callsCount2Months" && getArrowIcon()} Last 2 months calls
            </Link>
            <div style={{ display: "flex", gap: 4 }}>
              <Form
                name="form_callsCount2Months_from"
                fields={[
                  {
                    name: ["callsCount2MonthsFrom"],
                    value: currentSearchParams?.callsCount2MonthsFrom || "",
                  },
                ]}
              >
                <Form.Item style={{ margin: 0, padding: 0 }} name="callsCount2MonthsFrom">
                  <Input
                    type="number"
                    allowClear
                    style={{ width: 60 }}
                    onBlur={(e) => {
                      if (e.target.value) {
                        setSearchParams({
                          ...currentSearchParams,
                          page: "1",
                          callsCount2MonthsFrom: e.target.value,
                        });
                      } else {
                        searchParams.delete("callsCount2MonthsFrom");
                        setSearchParams(searchParams);
                      }
                    }}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        searchParams.delete("callsCount2MonthsFrom");
                        setSearchParams(searchParams);
                      }
                    }}
                    onPressEnter={(e) => {
                      const target = e.target as HTMLInputElement;
                      target.blur();
                    }}
                    size="small"
                    placeholder="From"
                  />
                </Form.Item>
              </Form>
              <Form
                name="form_callsCount2Months_to"
                fields={[
                  {
                    name: ["callsCount2MonthsTo"],
                    value: currentSearchParams?.callsCount2MonthsTo || "",
                  },
                ]}
              >
                <Form.Item style={{ margin: 0, padding: 0 }} name="callsCount2MonthsTo">
                  <Input
                    type="number"
                    allowClear
                    style={{ width: 60 }}
                    onBlur={(e) => {
                      if (e.target.value) {
                        setSearchParams({
                          ...currentSearchParams,
                          page: "1",
                          callsCount2MonthsTo: e.target.value,
                        });
                      } else {
                        searchParams.delete("callsCount2MonthsTo");
                        setSearchParams(searchParams);
                      }
                    }}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        searchParams.delete("callsCount2MonthsTo");
                        setSearchParams(searchParams);
                      }
                    }}
                    onPressEnter={(e) => {
                      const target = e.target as HTMLInputElement;
                      target.blur();
                    }}
                    size="small"
                    placeholder="To"
                  />
                </Form.Item>
              </Form>
            </div>
          </div>
        ),
        dataIndex: "callsCount2Months",
        key: "callsCount2Months",
        width: 250,
        minWidth: 250,
        render: (text: string) => (
          <div
            style={{ whiteSpace: "nowrap", minWidth: "35px", width: "35px" }}
          >
            {text}
          </div>
        ),
      },
      {
        title: (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Conversion calls</span>
          </div>
        ),
        dataIndex: "conversionCallsCount",
        key: "conversionCallsCount",
        width: 130,
        minWidth: 130,
        render: (text: React.ReactNode) => (
          <div
            style={{ whiteSpace: "nowrap", minWidth: "35px", width: "35px" }}
          >
            {text}
          </div>
        ),
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Domain Status</span>
            <Form
              name="form_domain_status"
              fields={[
                {
                  name: ["domainStatusText"],
                  value: currentSearchParams?.domainStatusText || "",
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="domainStatusText">
                <Input
                  allowClear
                  style={{ width: 140 }}
                  onBlur={(e) => {
                    if (e.target.value) {
                      setSearchParams({
                        ...currentSearchParams,
                        page: "1",
                        domainStatusText: e.target.value,
                      });
                    } else {
                      searchParams.delete("domainStatusText");
                      setSearchParams(searchParams);
                    }
                  }}
                  onChange={(e) => {
                    if (e.target.value === "") {
                      searchParams.delete("domainStatusText");
                      setSearchParams(searchParams);
                    }
                  }}
                  onPressEnter={(e) => {
                    const target = e.target as HTMLInputElement;
                    target.blur();
                  }}
                  size="small"
                  placeholder="Status"
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "domainStatusText",
        key: "domainStatusText",
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Auto Renew</span>
            <Form
              name="form_domain_auto_renew"
              fields={[
                {
                  name: ["domainAutoRenew"],
                  value: currentSearchParams?.domainAutoRenew || "",
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="domainAutoRenew">
                <Select
                  size="small"
                  allowClear
                  showSearch
                  style={{ minWidth: 100 }}
                  placeholder="Auto Renew"
                  onChange={(value: string) => {
                    if (value) {
                      setSearchParams({
                        ...currentSearchParams,
                        page: "1",
                        domainAutoRenew: value,
                      });
                    } else {
                      searchParams.delete("domainAutoRenew");
                      setSearchParams(searchParams);
                    }
                  }}
                  optionFilterProp="children"
                  options={[
                    { value: "true", label: "true" },
                    { value: "false", label: "false" },
                  ]}
                  filterOption={filterOption}
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "domainAutoRenew",
        key: "domainAutoRenew",
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Registrar</span>
            <Form
              name="form_domain_registrar"
              fields={[
                {
                  name: ["domainRegistrar"],
                  value: currentSearchParams?.domainRegistrar || "",
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="domainRegistrar">
                <Input
                  allowClear
                  style={{ width: 100 }}
                  onBlur={(e) => {
                    if (e.target.value) {
                      setSearchParams({
                        ...currentSearchParams,
                        page: "1",
                        domainRegistrar: e.target.value,
                      });
                    } else {
                      searchParams.delete("domainRegistrar");
                      setSearchParams(searchParams);
                    }
                  }}
                  onChange={(e) => {
                    if (e.target.value === "") {
                      searchParams.delete("domainRegistrar");
                      setSearchParams(searchParams);
                    }
                  }}
                  onPressEnter={(e) => {
                    const target = e.target as HTMLInputElement;
                    target.blur();
                  }}
                  size="small"
                  placeholder="Registrar"
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "domainRegistrar",
        key: "domainRegistrar",
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Project</span>
            <Form
              name="form_domain_project"
              fields={[
                {
                  name: ["domainProject"],
                  value: currentSearchParams?.domainProject || "",
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="domainProject">
                <Input
                  allowClear
                  style={{ width: 100 }}
                  onBlur={(e) => {
                    if (e.target.value) {
                      setSearchParams({
                        ...currentSearchParams,
                        page: "1",
                        domainProject: e.target.value,
                      });
                    } else {
                      searchParams.delete("domainProject");
                      setSearchParams(searchParams);
                    }
                  }}
                  onChange={(e) => {
                    if (e.target.value === "") {
                      searchParams.delete("domainProject");
                      setSearchParams(searchParams);
                    }
                  }}
                  onPressEnter={(e) => {
                    const target = e.target as HTMLInputElement;
                    target.blur();
                  }}
                  size="small"
                  placeholder="Project"
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "domainProject",
        key: "domainProject",
      },
      {
        title: (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Link
              onClick={() => {
                currentSearchParams?.sortByField !== "domainDaysUntilValid"
                  ? clickSortByField("domainDaysUntilValid")
                  : setSort();
              }}
              style={{ marginBottom: 4 }}
            >
              {sortByField === "domainDaysUntilValid" && getArrowIcon()} Days Until Valid
            </Link>
            <div style={{ display: "flex", gap: 4 }}>
              <Form
                name="form_domain_days_from"
                fields={[
                  {
                    name: ["domainDaysUntilValidFrom"],
                    value: currentSearchParams?.domainDaysUntilValidFrom || "",
                  },
                ]}
              >
                <Form.Item style={{ margin: 0, padding: 0 }} name="domainDaysUntilValidFrom">
                  <Input
                    type="number"
                    allowClear
                    style={{ width: 60 }}
                    onBlur={(e) => {
                      if (e.target.value) {
                        setSearchParams({
                          ...currentSearchParams,
                          page: "1",
                          domainDaysUntilValidFrom: e.target.value,
                        });
                      } else {
                        searchParams.delete("domainDaysUntilValidFrom");
                        setSearchParams(searchParams);
                      }
                    }}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        searchParams.delete("domainDaysUntilValidFrom");
                        setSearchParams(searchParams);
                      }
                    }}
                    onPressEnter={(e) => {
                      const target = e.target as HTMLInputElement;
                      target.blur();
                    }}
                    size="small"
                    placeholder="From"
                  />
                </Form.Item>
              </Form>
              <Form
                name="form_domain_days_to"
                fields={[
                  {
                    name: ["domainDaysUntilValidTo"],
                    value: currentSearchParams?.domainDaysUntilValidTo || "",
                  },
                ]}
              >
                <Form.Item style={{ margin: 0, padding: 0 }} name="domainDaysUntilValidTo">
                  <Input
                    type="number"
                    allowClear
                    style={{ width: 60 }}
                    onBlur={(e) => {
                      if (e.target.value) {
                        setSearchParams({
                          ...currentSearchParams,
                          page: "1",
                          domainDaysUntilValidTo: e.target.value,
                        });
                      } else {
                        searchParams.delete("domainDaysUntilValidTo");
                        setSearchParams(searchParams);
                      }
                    }}
                    onChange={(e) => {
                      if (e.target.value === "") {
                        searchParams.delete("domainDaysUntilValidTo");
                        setSearchParams(searchParams);
                      }
                    }}
                    onPressEnter={(e) => {
                      const target = e.target as HTMLInputElement;
                      target.blur();
                    }}
                    size="small"
                    placeholder="To"
                  />
                </Form.Item>
              </Form>
            </div>
          </div>
        ),
        dataIndex: "domainDaysUntilValid",
        key: "domainDaysUntilValid",
        width: 250,
        minWidth: 250,
        render: (text: string) => (
          <div
            style={{ whiteSpace: "nowrap", minWidth: "35px", width: "35px" }}
          >
            {text}
          </div>
        ),
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Labels</span>
            <Form
              name="form_labels"
              fields={[
                {
                  name: ["labels"],
                  value: currentSearchParams?.labels?.split(",") || [],
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="labels">
                <Select
                  mode="multiple"
                  size="small"
                  showSearch
                  style={{ minWidth: 120 }}
                  placeholder="Filter by labels"
                  onChange={(value: string) => {
                    if (value.length > 0) {
                      setSearchParams({
                        ...currentSearchParams,
                        page: "1",
                        labels: value.toString(),
                      });
                    } else {
                      searchParams.delete("labels");
                      setSearchParams(searchParams);
                    }
                  }}
                  optionFilterProp="children"
                  options={allLabels.map((l) => ({
                    value: l._id,
                    label: l.name,
                  }))}
                  filterOption={filterOption}
                  notFoundContent={
                    allLabels.length === 0
                      ? "No labels available"
                      : "No labels found"
                  }
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "labels",
        key: "labels",
      },
      {
        title: (
          <Link
            onClick={() => {
              currentSearchParams?.sortByField !== "createdAt"
                ? clickSortByField("createdAt")
                : setSort();
            }}
          >
            {sortByField === "createdAt" && getArrowIcon()} Created
          </Link>
        ),
        dataIndex: "created",
        key: "created",
      },
      {
        title: (
          <Link
            onClick={() => {
              currentSearchParams?.sortByField !== "updatedAt"
                ? clickSortByField("updatedAt")
                : setSort();
            }}
          >
            {sortByField === "updatedAt" && getArrowIcon()} Updated
          </Link>
        ),
        dataIndex: "updated",
        key: "updated",
      },
      {
        title: () => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginBottom: 4 }}>Error</span>
            <Form
              name="form_error"
              fields={[
                {
                  name: ["errors"],
                  value: currentSearchParams?.error || "",
                },
              ]}
            >
              <Form.Item style={{ margin: 0, padding: 0 }} name="errors">
                <Select
                  size="small"
                  showSearch
                  style={{ minWidth: 80 }}
                  placeholder="Error"
                  onChange={handleChangeIsError}
                  optionFilterProp="children"
                  options={[
                    { value: "true", label: "true" },
                    { value: "false", label: "false" },
                  ]}
                  filterOption={filterOption}
                />
              </Form.Item>
            </Form>
          </div>
        ),
        dataIndex: "isError",
        key: "isError",
      },
    ]);
  }, [
    currentSearchParams,
    isGettingStatesInProgress,
    formattedStates,
    states,
    companies,
    currentSearchParams?.serchByZip,
    checkedSites,
    allSitesIds,
    allLabels,
  ]);

  useEffect(() => {
    console.log("currentSearchParams", currentSearchParams);
    dispatch(
      setSortBy((currentSearchParams?.sortBy as "desc" | "asc") || "desc")
    );
    dispatch(
      setSortByField(
        (currentSearchParams?.sortByField as SortByField) || "createdAt"
      )
    );
    dispatch(
      setPage(currentSearchParams?.page ? Number(currentSearchParams?.page) : 1)
    );
    dispatch(setSearchByName(currentSearchParams?.serchByName || ""));

    dispatch(setSearchByState(currentSearchParams?.state || ""));
    dispatch(setSearchByCity(currentSearchParams?.city || ""));
    dispatch(setSearchByZip(currentSearchParams?.serchByZip || ""));
    dispatch(setSerchByDomain(currentSearchParams?.serchByDomain || ""));
    dispatch(setSearchByCompany(currentSearchParams?.company || ""));
    dispatch(setSearchByStatus(currentSearchParams?.status || ""));
    dispatch(setSearchByCounty(currentSearchParams?.county || ""));
    dispatch(setSearchByError(currentSearchParams?.error || ""));
    dispatch(setSearchByInProgress(currentSearchParams?.inProgress || ""));
    dispatch(setSearchByLabels(currentSearchParams?.labels || ""));
  }, [currentSearchParams]);

  useEffect(() => {
    setCurrentSearchParams(Object.fromEntries([...searchParams]));
  }, [searchParams]);

  const onPageChange = (current: number) => {
    setSearchParams({ ...currentSearchParams, page: `${current}` });
  };

  const onChangeDateStart: DatePickerProps["onChange"] = (date, dateString) => {
    console.log(date, dateString);
    setStartDate(String(dateString));
  };
  const onChangeDateFinish: DatePickerProps["onChange"] = (
    date,
    dateString
  ) => {
    console.log(date, dateString);
    setFinishDate(String(dateString));
  };

  const handlePageSizeChange = (value: number) => {
    localStorage.setItem("sitesPageSize", String(value));
    dispatch(setPageSize(value));
    setSearchParams({ ...currentSearchParams, page: "1" });
  };

  const handleResetSort = () => {
    setSearchParams({
      ...currentSearchParams,
      sortBy: "desc",
      sortByField: "createdAt",
      page: "1",
    });
  };

  const handleResetFilters = () => {
    setSearchParams({
      sortBy: "desc",
      sortByField: "createdAt",
      page: "1",
    });
  };

  const availableColumns = [
    { key: "name", label: "Site name" },
    { key: "state", label: "State" },
    { key: "city", label: "City" },
    { key: "zip", label: "Zip" },
    { key: "county", label: "County" },
    { key: "company", label: "Company" },
    { key: "domain", label: "Domain" },
    { key: "status", label: "Status" },
    { key: "created", label: "Created" },
    { key: "updated", label: "Updated" },
    { key: "isError", label: "Error" },
    { key: "inProgress", label: "In Progress" },
    { key: "callsCount", label: "Total Calls" },
    { key: "callsCount2Months", label: "Last 2 months calls" },
    { key: "conversionCallsCount", label: "Conversion calls" },
    { key: "domainStatusText", label: "Domain Status" },
    { key: "domainAutoRenew", label: "Auto Renew" },
    { key: "domainRegistrar", label: "Registrar" },
    { key: "domainProject", label: "Project" },
    { key: "domainDaysUntilValid", label: "Days Until Valid" },
    { key: "labels", label: "Labels" },
  ];

  const handleColumnToggle = (columnKey: string) => {
    setSelectedColumns((prev) =>
      prev.includes(columnKey)
        ? prev.filter((key) => key !== columnKey)
        : [...prev, columnKey]
    );
  };

  const handleSelectAllColumns = () => {
    if (selectedColumns.length === availableColumns.length) {
      setSelectedColumns([]);
    } else {
      setSelectedColumns(availableColumns.map((col) => col.key));
    }
  };

  const extractTextFromReactElement = (element: any): string => {
    if (typeof element === "string") return element;
    if (typeof element === "number") return String(element);
    if (!element) return "";
    if (React.isValidElement(element)) {
      const props = element.props as any;
      if (props.children) {
        if (Array.isArray(props.children)) {
          return props.children
            .map(extractTextFromReactElement)
            .join(" ");
        }
        return extractTextFromReactElement(props.children);
      }
      if (props.href) return props.href;
      if (element.type === "img" && props.alt) return props.alt;
    }
    return "";
  };

  const exportToCSV = () => {
    const csvRows: string[] = [];

    // Add header
    const headers = selectedColumns.map((columnKey) => {
      const column = availableColumns.find((col) => col.key === columnKey);
      return column ? column.label : columnKey;
    });
    csvRows.push(headers.join(","));

    // Add data rows
    dataSource.forEach((row) => {
      const values = selectedColumns.map((columnKey) => {
        const value = row[columnKey as keyof ISiteRow];
        const textValue = extractTextFromReactElement(value);
        // Escape quotes and wrap in quotes if contains comma
        const escaped = String(textValue).replace(/"/g, '""');
        return escaped.includes(",") ? `"${escaped}"` : escaped;
      });
      csvRows.push(values.join(","));
    });

    // Create blob and download
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `sites_export_${new Date().toISOString().split("T")[0]}.csv`
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setIsExportModalOpen(false);
  };

  const exportExpirationAnalysisToCSV = () => {
    const expirationMap: { [date: string]: number } = {};
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Group sites by expiration date
    sites.forEach((site) => {
      if (site.domainDaysUntilValid !== undefined && site.domainDaysUntilValid !== null) {
        const daysUntilValid = site.domainDaysUntilValid;
        const expirationDate = new Date(today);
        expirationDate.setDate(expirationDate.getDate() + daysUntilValid);

        const dateString = expirationDate.toISOString().split("T")[0];
        expirationMap[dateString] = (expirationMap[dateString] || 0) + 1;
      }
    });

    // Sort by date
    const sortedDates = Object.keys(expirationMap).sort();

    // Create CSV
    const csvRows: string[] = [];
    csvRows.push("Date,Count");

    sortedDates.forEach((date) => {
      csvRows.push(`${date},${expirationMap[date]}`);
    });

    // Create blob and download
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `domain_expiration_analysis_${new Date().toISOString().split("T")[0]}.csv`
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setIsExportExpirationModalOpen(false);
  };

  return (
    <div style={{ position: "relative" }}>
      {isGettingSitesInProgress && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.15)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
            size="large"
          />
        </div>
      )}
      <div>
      <div
        style={{
          paddingBottom: 20,
          paddingTop: 20,
          display: "flex",
          alignItems: "center",
          gap: 16,
        }}
      >
        {sitesTotal > 0 && (
          <>
            <Pagination
              showTotal={(total) => `Total ${total} items`}
              pageSize={pageSize}
              defaultCurrent={1}
              current={
                currentSearchParams?.page
                  ? Number(currentSearchParams?.page)
                  : 1
              }
              total={sitesTotal}
              onChange={onPageChange}
              showSizeChanger={false}
            />
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span>Page size:</span>
              <Select
                value={pageSize}
                style={{ width: 100 }}
                onChange={handlePageSizeChange}
                options={[
                  { value: 20, label: "20" },
                  { value: 50, label: "50" },
                  { value: 100, label: "100" },
                  { value: 500, label: "500" },
                  { value: 1000, label: "1000" },
                  { value: 5000, label: "5000" },
                ]}
              />
            </div>
            {(currentSearchParams?.sortBy !== "desc" ||
              currentSearchParams?.sortByField !== "createdAt") && (
              <Button size="small" onClick={handleResetSort}>
                Reset Sort
              </Button>
            )}
            {Object.keys(currentSearchParams || {}).some(
              (key) =>
                key !== "sortBy" &&
                key !== "sortByField" &&
                key !== "page" &&
                key !== "pageSize"
            ) && (
              <Button size="small" onClick={handleResetFilters} danger>
                Reset Filters
              </Button>
            )}
            <Button
              type="primary"
              size="small"
              onClick={() => setIsExportModalOpen(true)}
            >
              Export to CSV
            </Button>
            <Button
              type="default"
              size="small"
              onClick={() => setIsExportExpirationModalOpen(true)}
            >
              Export Expiration Analysis
            </Button>
          </>
        )}
      </div>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        rowClassName={(record) => {
          // Find the site by checking the key (which is site._id)
          const site = sites.find((s) => s._id === record.key);
          return site?.domainAutoRenew === false ? "auto-renew-disabled-row" : "";
        }}
      />
      <div
        style={{
          paddingTop: 20,
          display: "flex",
          alignItems: "center",
          gap: 16,
        }}
      >
        {sitesTotal > 0 && (
          <>
            <Pagination
              showTotal={(total) => `Total ${total} items`}
              pageSize={pageSize}
              defaultCurrent={1}
              current={
                currentSearchParams?.page
                  ? Number(currentSearchParams?.page)
                  : 1
              }
              total={sitesTotal}
              onChange={onPageChange}
              showSizeChanger={false}
            />
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span>Page size:</span>
              <Select
                value={pageSize}
                style={{ width: 100 }}
                onChange={handlePageSizeChange}
                options={[
                  { value: 20, label: "20" },
                  { value: 50, label: "50" },
                  { value: 100, label: "100" },
                  { value: 500, label: "500" },
                  { value: 1000, label: "1000" },
                  { value: 5000, label: "5000" },
                ]}
              />
            </div>
            {(currentSearchParams?.sortBy !== "desc" ||
              currentSearchParams?.sortByField !== "createdAt") && (
              <Button size="small" onClick={handleResetSort}>
                Reset Sort
              </Button>
            )}
          </>
        )}
      </div>
      <Modal
        width={800}
        title={`${activeDomain}`}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={
          <Button type="primary" onClick={handleCancel}>
            Close
          </Button>
        }
      >
        <Space direction="horizontal">
          <DatePicker onChange={onChangeDateStart} />
          <DatePicker onChange={onChangeDateFinish} />
        </Space>
        {isLoadStatisticInProgress ? (
          <p>Loading...</p>
        ) : (
          <div>
            {statistics?.split("\n").map((stat) => (
              <p>
                {stat}{" "}
                {!!stat && (
                  <Popconfirm
                    title={stat.split(",")?.[0]}
                    description={`Write article?`}
                    onConfirm={() =>
                      !isWritingArticleInProgress
                        ? dispatch(
                            writeArticle(activeSiteId, stat.split(",")?.[0])
                          )
                        : null
                    }
                  >
                    <span
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "red",
                      }}
                    >
                      {isWritingArticleInProgress
                        ? "loading..."
                        : "Create article"}
                    </span>
                  </Popconfirm>
                )}
                {!!stat && " / "}
                {!!stat && (
                  <Popconfirm
                    title={stat.split(",")?.[0]}
                    description={`Write review?`}
                    onConfirm={() =>
                      !isWritingArticleInProgress
                        ? dispatch(
                            writeArticle(
                              activeSiteId,
                              stat.split(",")?.[0],
                              true
                            )
                          )
                        : null
                    }
                  >
                    <span
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "red",
                      }}
                    >
                      {isWritingArticleInProgress
                        ? "loading..."
                        : "Create review"}
                    </span>
                  </Popconfirm>
                )}
              </p>
            ))}
          </div>
        )}
      </Modal>
      <Modal
        title="Export to CSV"
        open={isExportModalOpen}
        onCancel={() => setIsExportModalOpen(false)}
        onOk={exportToCSV}
        okText="Export"
        cancelText="Cancel"
        width={500}
      >
        <div style={{ marginBottom: 16 }}>
          <Checkbox
            checked={selectedColumns.length === availableColumns.length}
            indeterminate={
              selectedColumns.length > 0 &&
              selectedColumns.length < availableColumns.length
            }
            onChange={handleSelectAllColumns}
          >
            Select All
          </Checkbox>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "8px",
          }}
        >
          {availableColumns.map((column) => (
            <Checkbox
              key={column.key}
              checked={selectedColumns.includes(column.key)}
              onChange={() => handleColumnToggle(column.key)}
            >
              {column.label}
            </Checkbox>
          ))}
        </div>
      </Modal>
      <Modal
        title="Export Domain Expiration Analysis"
        open={isExportExpirationModalOpen}
        onCancel={() => setIsExportExpirationModalOpen(false)}
        onOk={exportExpirationAnalysisToCSV}
        okText="Export"
        cancelText="Cancel"
        width={500}
      >
        <p>
          This will export a CSV file containing the count of domains expiring on each date.
        </p>
        <p>
          The export will include all sites currently loaded on this page with valid domain expiration data.
        </p>
      </Modal>
      </div>
    </div>
  );
};
